/* eslint-disable func-names */
import { Button, Input } from "@mui/material";
import { ChangeEvent, useEffect, useState } from "react";

import { UploadIcon } from "../../../../../assets/iconsSVG";
import * as Styles from "../../../styles";

interface Props {
  value: any;
  functionComment: any;
  functionFile?: any;
  valueFile: Function;
  valueFileBased: Function;
  count: number;
}

export function DefaultForm(props: Props) {
  const [filename, setFilename] = useState<any>("");
  const [fileBasedSplit, setfileBasedSplit] = useState<any>("");
  const [backgroundButton, setBackgroundButton] = useState<string>("white");

  useEffect(() => {
    if (filename) {
      setBackgroundButton("#cecece");
    } else {
      setBackgroundButton("white");
    }

    // Notificar o componente pai sobre mudanças no filename
    props.valueFile(filename);
  }, [filename, props.valueFile]);

  useEffect(() => {
    // Notificar o componente pai sobre mudanças no fileBasedSplit
    props.valueFileBased(fileBasedSplit);
  }, [fileBasedSplit, props.valueFileBased]);

  const handleFileUpload = (e: ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) {
      return;
    }
    const file = e.target.files[0];
    const { name } = file;
    setFilename(name);

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      const fileBased: any = reader.result;
      const basedSplit = fileBased.split("base64,")[1];

      setfileBasedSplit(basedSplit);
    };
    reader.onerror = function (error) {
      console.log("Error: ", error);
    };
  };

  return (
    <>
      <Styles.TransferComponent style={{ paddingBottom: 0, minHeight: 0 }}>
        <Styles.MultLineField>
          <Styles.LabelText>Observação sobre o resultado *</Styles.LabelText>
          <Styles.TextField
            onChange={props.functionComment}
            label="Multiline"
            variant="outlined"
            fullWidth
            multiline
            minRows={3}
            value={props.value}
            defaultValue={props.value}
            inputProps={{ maxLength: 5000 }}
          />
          <Styles.CountText>{props.count}/5000</Styles.CountText>
        </Styles.MultLineField>
        <Styles.MultLineField>
          <Styles.LabelText>Anexo {filename}</Styles.LabelText>
          <Button
            className="button-file"
            style={{ background: backgroundButton }}
            component="label"
          >
            <Input
              id="upload"
              style={{ display: "none" }}
              name="upload"
              type="file"
              value={props.valueFile}
              defaultValue={props.valueFile}
              onChange={handleFileUpload}
            />
            <UploadIcon /> {filename || "Carregar anexo"}
          </Button>
        </Styles.MultLineField>
      </Styles.TransferComponent>
    </>
  );
}
